import { colorsPalettes } from "@similarweb/styles";

import type { IDiscountPopupTheme } from "../types";

// Update this for only timer
const DEFAULT_POPUP_THEME: IDiscountPopupTheme = {
    background: `linear-gradient(48deg, ${colorsPalettes.midnight[500]} 0%, ${colorsPalettes.blue[400]} 99.18%)`,
    giftImageIcon: "/images/basic-gift.svg",
    CTAButtonType: "inverted",
    closeButtonColor: colorsPalettes.carbon[0],
    titleColor: colorsPalettes.blue[50],
    headingColor: colorsPalettes.bluegrey[100],
    subtitleColor: colorsPalettes.blue[50],
    discountTextColor: colorsPalettes.blue[50],
    timeValueColor: colorsPalettes.carbon[0],
    timeLabelColor: colorsPalettes.carbon[0],
    footerTextColor: colorsPalettes.blue[50],
    timeBoxWrapperBorderColor: colorsPalettes.carbon[0],
    timeBoxWrapperBackground: `linear-gradient(206deg, ${colorsPalettes.carbon[0]} -155.94%, rgba(${colorsPalettes.carbon[0]}, 0), 135.15%)`,
};

export { DEFAULT_POPUP_THEME as defaultDiscountPopupTheme };
